module.exports = __webpack_public_path__ + "static/media/drumset.1db987fb.jpg";